import type { PublicOrganization } from './organization';
import type { TranslatedString } from './shared';

export enum DowntimeSchedulePlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export enum DowntimeScheduleState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  INACTIVE = 'INACTIVE',
}

export enum DowntimeScheduleTransitionStates {
  activate = 'activate',
  archive = 'archive',
  deactivate = 'deactivate',
}

export type DowntimeSchedule = {
  id: string;
  name: string;
  translatedNote?: TranslatedString;
  platforms?: DowntimeSchedulePlatform[];
  startTime: Date;
  endTime?: Date;
  excludeRoles?: string[];
  helpLink?: string;
  state?: DowntimeScheduleState;
  organization: PublicOrganization;
  translatedDescription?: TranslatedString;
  translatedTitle: TranslatedString;
};
